import { Component } from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {FooterComponent} from './components/footer/footer.component';
import {HeaderComponent} from './components/header/header.component';
import {NgxSonnerToaster} from 'ngx-sonner';
import {ConsentBannerComponent} from './components/consent-banner/consent-banner.component';
import {TrackingService} from './service/tracking.service';



@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    FooterComponent,
    HeaderComponent,
    NgxSonnerToaster,
    ConsentBannerComponent,


  ],
  templateUrl: './app.component.html',
})
export class AppComponent {
  /** The admin page is opened directly and has its own layout: no site header, footer or banner. */
  readonly privatePage = TrackingService.isPrivatePage();

}
